import { z } from 'zod';

export const odometerInKmFormValidation = z.number({ required_error: 'A quilometragem é obrigatória' }).min(1, 'A quilometragem deve ser maior que zero');

export const driverNameFormValidation = z.string().optional();
export const fuelTypeFormValidation = z.string({ required_error: 'O tipo de combustível é obrigatório' }).min(1, 'O tipo de combustível é obrigatório');
export const totalCostFormValidation = z.number({ required_error: 'O custo total é obrigatório' }).min(1, 'O custo total é obrigatório');
export const quantityInLitersFormValidation = z.number({ required_error: 'A quantidade em litros é obrigatória' }).min(1, 'A quantidade em litros é obrigatória');

export const merchantNameFormValidation = z.string().optional();
export const merchantStateFormValidation = z
  .string()
  .optional()
  .refine((value) => !value || value.length === 2, 'Use apenas 2 letras para a sigla do estado');
export const merchantCityFormValidation = z.string().optional();
export const merchantCnpjFormValidation = z.string().optional();
